// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"_3oLQhaDEh8EuJmdZAbrM5g","closeIcon":"_2KLecXnHyuRJpHgzbW2krw","item":"_3ymv1Lmal0621QYBly39jU"};